import { mixNumber as p } from "./atoms-v2981.js";
import { warning as f } from "./atoms-v2886.js";
import { hslaToRgba as c } from "./atoms-v21225.js";
import { hex as u } from "./atoms-v2954.js";
import { rgba as s } from "./atoms-v2956.js";
import { hsla as l } from "./atoms-v2955.js";
import { mixImmediate as d } from "./atoms-v21126.js";
const m = (o, e, r) => {
  const t = o * o, n = r * (e * e - t) + t;
  return n < 0 ? 0 : Math.sqrt(n);
}, b = [u, s, l], h = (o) => b.find((e) => e.test(o));
function i(o) {
  const e = h(o);
  if (f(!!e, `'${o}' is not an animatable color. Use the equivalent color code instead.`), !e)
    return !1;
  let r = e.parse(o);
  return e === l && (r = c(r)), r;
}
const G = (o, e) => {
  const r = i(o), t = i(e);
  if (!r || !t)
    return d(o, e);
  const n = { ...r };
  return (a) => (n.red = m(r.red, t.red, a), n.green = m(r.green, t.green, a), n.blue = m(r.blue, t.blue, a), n.alpha = p(r.alpha, t.alpha, a), s.transform(n));
};
export {
  G as mixColor,
  m as mixLinearColor
};
